import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '@/context/LanguageContext';

const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, follow';
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);
};

const PrivacyPolicyPage = () => {
  const { lang, t } = useLang();
  const navigate = useNavigate();
  useNoIndex();

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  useEffect(() => {
    document.title = lang === 'fr'
      ? 'Politique de confidentialité | Red House Residency'
      : 'Privacy policy | Red House Residency';
  }, [lang]);

  const isFr = lang === 'fr';

  return (
    <main data-testid="privacy-page" className="bg-background min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <button
          type="button"
          onClick={handleBack}
          data-testid="back-button"
          className="text-sm text-[#555] hover:text-[#E92A3E] transition-colors mb-8"
        >
          {t('footer.back')}
        </button>

        <h1 className="font-heading text-4xl sm:text-5xl text-[#111] mb-12">
          {isFr ? 'Politique de confidentialité' : 'Privacy policy'}
        </h1>

        <div className="space-y-10 text-[#333] text-base leading-relaxed">
          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Responsable du traitement' : 'Data controller'}
            </h2>
            <p>MUSE ME (RED HOUSE RECORDS) — <a href="mailto:studio@redhouse.co" className="text-[#E92A3E] hover:underline">studio@redhouse.co</a></p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Données collectées' : 'Data collected'}
            </h2>
            <p>
              {isFr
                ? "Uniquement via le formulaire de candidature : nom, prénom, email, téléphone, projet artistique. Aucune donnée collectée par cookie ou tracker tiers."
                : 'Only via the application form: first name, last name, email, phone, artistic project. No data collected through cookies or third-party trackers.'}
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Finalité' : 'Purpose'}
            </h2>
            <p>
              {isFr
                ? "Répondre aux candidatures de résidence artistique. Aucune utilisation commerciale, aucun transfert à des tiers."
                : 'To respond to artist residency applications. No commercial use, no transfer to third parties.'}
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Durée de conservation' : 'Retention period'}
            </h2>
            <p>
              {isFr
                ? '3 ans à compter du dernier contact.'
                : '3 years from the last contact.'}
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Vos droits (RGPD)' : 'Your rights (GDPR)'}
            </h2>
            <p>
              {isFr
                ? "Droit d'accès, rectification, suppression, opposition. Demande à adresser à : "
                : 'Right of access, rectification, erasure, objection. Request to be sent to: '}
              <a href="mailto:studio@redhouse.co" className="text-[#E92A3E] hover:underline">studio@redhouse.co</a>.
              {' '}
              {isFr
                ? 'Réclamation possible auprès de la CNIL : '
                : 'Complaint possible to the CNIL: '}
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#E92A3E] hover:underline">https://www.cnil.fr</a>
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicyPage;
